import { Competition } from 'business';
import { useQuery } from 'bridge';

export default function useGroupCompetitions(groupId: string, now?: Date) : Competition[] | undefined {

    const groupCompetitions = useQuery<Competition>({ groupId: groupId, queryType: 'groupCompetitions', date: now});
    return groupCompetitions;
}

